import { NavLink, Outlet, useLocation } from 'react-router-dom';

const TABS = [
  { id: 'empresas', label: 'Empresas', path: '/config/financeiro/empresas' },
  { id: 'contas', label: 'Contas Correntes', path: '/config/financeiro/contas' },
  { id: 'cartoes', label: 'Cartões', path: '/config/financeiro/cartoes' },
  { id: 'categorias', label: 'Categorias', path: '/config/financeiro/categorias' },
  { id: 'regras', label: 'Regras', path: '/config/financeiro/regras' },
] as const;

export function ConfigFinanceiroLayout() {
  const location = useLocation();
  const activeId = TABS.find((t) => location.pathname.startsWith(t.path))?.id ?? 'empresas';

  return (
    <div className="space-y-4">
      <nav className="flex gap-1 border-b border-border">
        {TABS.map((t) => (
          <NavLink
            key={t.id}
            to={t.path}
            className={
              t.id === activeId
                ? 'text-sm px-4 py-2 -mb-px border-b-2 border-ink-primary text-ink-primary font-medium'
                : 'text-sm px-4 py-2 -mb-px border-b-2 border-transparent text-ink-tertiary hover:text-ink-secondary'
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
